import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

const money = (n) => `${Number(n || 0).toLocaleString("fr-CA", { minimumFractionDigits: 0, maximumFractionDigits: 0 })} $`;

// Accueil : la discipline qui décroche le plus vs son objectif du mois + membres en retard / sans encaissement.
export function DisciplineAlertCard() {
  const [d, setD] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const navigate = useNavigate();
  useEffect(() => { api.get("/ops/discipline-alert").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  const a = d?.alert;
  if (!a) return null;
  const people = [...a.late, ...a.no_payment];
  const shown = showAll ? people : people.slice(0, 6);
  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-4 rounded-xl border border-rose-500/50 bg-rose-500/[0.06] p-4" data-testid="discipline-alert-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-rose-300 font-semibold">Décrochage · {a.month_label}</p>
          <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="discipline-alert-title">{a.label} : {a.pct} % de son objectif, attendu {a.expected_pct} % (−{a.gap} pts)</h3>
          <p className="text-xs text-zinc-400 mt-0.5" data-testid="discipline-alert-hint">
            {money(a.collected)} encaissés sur {money(a.goal)} · {a.contracts} contrats · ≈ {money(a.missing)} manquants pour être au rythme · {a.late.length} en retard · {a.no_payment.length} sans encaissement ce mois-ci
          </p>
        </div>
        <button onClick={() => navigate("/app/membres-paiements?tab=defaut")} className="px-3 py-1.5 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-xs text-zinc-200" data-testid="discipline-alert-dues">Présents non payés →</button>
      </div>
      {people.length > 0 && (
        <ul className="mt-3 divide-y divide-zinc-800/70" data-testid="discipline-alert-list">
          {shown.map((p) => (
            <li key={p.contract_id} className="py-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs" data-testid={`discipline-alert-row-${p.contract_id}`}>
              <span className={`w-2 h-2 rounded-full ${p.kind === "retard" ? "bg-rose-400" : "bg-amber-400"}`} title={p.kind === "retard" ? "en retard" : "sans encaissement ce mois-ci"} />
              <span className="text-zinc-100 font-medium" data-testid={`discipline-alert-name-${p.contract_id}`}>{p.full_name}</span>
              <span className="text-zinc-400 flex-1 min-w-[160px]">{p.reason}{p.last_presence ? ` · vu le ${p.last_presence}` : ""}</span>
              <span className="text-zinc-200 whitespace-nowrap">≈ {money(p.amount_due_est)}</span>
              {p.phone && <a href={`tel:${p.phone}`} className="text-[#C9A961] hover:underline" data-testid={`discipline-alert-call-${p.contract_id}`}>📞</a>}
              {p.email && <a href={`mailto:${p.email}`} className="text-[#C9A961] hover:underline" data-testid={`discipline-alert-mail-${p.contract_id}`}>✉️</a>}
            </li>
          ))}
        </ul>
      )}
      {people.length > 6 && <button onClick={() => setShowAll((v) => !v)} className="mt-2 text-xs text-rose-300 underline" data-testid="discipline-alert-more">{showAll ? "Réduire" : `Voir les ${people.length - 6} autres`}</button>}
    </div>
  );
}
